import {Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {JsonEditorComponent, JsonEditorOptions} from 'ang-jsoneditor';
import {HttpHeaders, HttpParams} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {ConfService} from '../../../conf.service';
import {ConnecttocrudService} from '../../../connecttocrud.service';
import {ActivatedRoute, Router} from '@angular/router';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar} from '@angular/material';
import {HeadersComponent, NewMockResponseEntryInputComponent} from '../../headers/headers.component';
import {AuthorizationComponent} from '../../../authorization/authorization.component';
import {LeftpanelComponent} from '../../../leftpanel/leftpanel.component';
import {DevexListenerService} from '../../../devex-listener.service';
import {Observable} from 'rxjs';
import {ICategory} from '../../../crudapi/crudapi.component';
import {FormControl} from '@angular/forms';
import 'ace-builds/src-min-noconflict/ace.js';
import 'ace-builds/src-min-noconflict/theme-monokai.js';
import 'ace-builds/src-min-noconflict/mode-python.js';
import 'ace-builds/src-min-noconflict/mode-javascript.js';
import 'ace-builds/src-min-noconflict/mode-ruby.js';
import 'ace-builds/src-min-noconflict/mode-golang.js';
import 'ace-builds/src-min-noconflict/mode-sh.js';
import 'ace-builds/src-min-noconflict/mode-java.js';

import 'ace-builds/src-noconflict/ace';
import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/theme-monokai';
import {CodeViewerComponent} from '../language-commands/ace-editor/code-viewer.component';
import {CurlGenerator} from 'curl-generator';

declare let $;

@Component({
  selector: 'method1-get',
  templateUrl: './api1-executor.component.html',
  styleUrls: ['./api1-executor.component.scss']
})

export class Api1ExecutorComponent implements OnInit, OnChanges {
  requestBodySelected = 'none';
  response: any;
  JSSnippet: string;
  curlSnippet: string;
  JavaSnippet: string;
  PySnippet: string;
  NodeSnippet: string;
  RubySnippet: string;
  GoSnippet: string;
  getResponse: any;
  getRequest: any;
  // description_flag: boolean;
  getHttpOptions: any;
  putResponse: any;
  putRequest: any;
  putHttpOptions: any;
  dataModelPost: any;
  dataModelPut: any;
  postResponse: any;
  postRequest: any;
  postHttpOptions: any;
  dataSource: any;
  deleteResponse: any;
  deleteRequest: any;
  deleteHttpOptions: any;
  partnerKey: string;
  partnerKeyToTest: string;
  dataModel: any;
  entity: string;
  version: string;
  environmentHeaders: any;
  @Input() operations: any;
  @Input() parameterData: any;
  @Input() headersData: any;
  @Input() pathParams: any;
  @Input() authModel: any;
  @Input() requestBody: any;
  @Input() prerequisites: any;
  @Input() description_flag: boolean;
  @Input() partner = localStorage.getItem('partner');
  @Input() account = localStorage.getItem('account');
  @Input() Entity: any;
  @Input() inlineedit = true;
  @Input() httpOperation = 'GET';
  @Input() apiType: string;
  @Input() attributes: any;
  @Input() disableExecutor = false;
  @Input() disableExpansion = false;

  @Input() entityApiResponses: any = [];
  @Output() eARChanged = new EventEmitter<any>();

  account_id: any;
  contentTypeExists: boolean;
  @ViewChild(JsonEditorComponent) editor: JsonEditorComponent;
  @ViewChild(HeadersComponent) headerChild: HeadersComponent;
  @ViewChild(AuthorizationComponent) authModel1: AuthorizationComponent;

  @ViewChild('codeViewer') codeViewer: CodeViewerComponent;
  isExpanded = false;

  operationsActions = [];

  columns: string[] = [];
  itemLength: any;
  isResponseAttributesPresent = false;
  responseCookies: any;
  responseCode: any;
  httpUrl: any;
  responseData: any;
  responseText: any;
  responseItems: any;
  responses: any;
  executeFlag = false;
  responseObject: any;
  responseError: any;
  responseTimestamp: any;
  responseHeaders: any;
  responseTime: any;
  itemList = [];
  userView = 'json';
  error = false;
  responseType: any;
  errorMessage: string;
  apiByDefinition: any;
  returnType: any;
  jsonViewer: any;

  rawRequestBody: any;
  formData = [];
  options1 = new JsonEditorOptions();
  selectedAttribute: any;

  languages = [
    {value: 'curl', viewValue: 'Shell', img: './assets/img/lang/shell.png', editorLang: 'sh'},
    {value: 'goNative', viewValue: 'Go-Native', img: './assets/img/lang/go.png', editorLang: 'golang'},
    {value: 'js', viewValue: 'JavaScript', img: './assets/img/lang/js.png', editorLang: 'javascript'},
    {value: 'java', viewValue: 'Java', img: './assets/img/lang/java.png', editorLang: 'java'},
    {value: 'node', viewValue: 'NodeJS', img: './assets/img/lang/nodejs.png', editorLang: 'javascript'},
    {value: 'python', viewValue: 'Python', img: './assets/img/lang/python.png', editorLang: 'python'},
    {value: 'ruby', viewValue: 'Ruby', img: './assets/img/lang/ruby.png', editorLang: 'ruby'},
  ];
  languageSnippets = [];

  selectedLanguage = this.languages[0].value;
  htmlViewType = 'raw';


  constructor(private _service: ConnecttocrudService, private confPost: ConfService,
              private route: ActivatedRoute, public dialog: MatDialog, public platform: LeftpanelComponent, private devexListenerInstance: DevexListenerService, private router: Router) {
    this.options1.mode = 'code';
    this.options1.modes = ['code', 'text', 'tree', 'view'];
    this.options1.schema = '';
    this.options1.statusBar = false;
    this.options1.onChange = () => console.log(/* this.editor.get()*/);
  }

  ngOnInit(): void {

    if (this.attributes) {
      for (const attribute of this.attributes) {
        if (attribute.subType.length === 0) {
          this.selectedAttribute = attribute['attributeName'];
          break;
        }
      }
      if (!this.selectedAttribute) {
        this.selectedAttribute = 'field';
      }
    }

    if (this.operations && this.operations.length > 0) {
      this.httpOperation = this.operations[0]['executor_method_type'];

      for (const operation of this.operations) {
        this.operationsActions = [];
        const displayName = operation['executor_display_name'] && operation['executor_display_name'] !== '' ? operation['executor_display_name'] : operation['executor__name'];
        this.operationsActions.push({expanded: true, edit_executor_display_name: false, display_name: displayName});
      }
    }
    if (this.partner !== undefined) {
      this.partnerKey = this.partner;
    } else {
      this.partnerKey = localStorage.getItem('partner');
    }
    if (this.account !== undefined) {
      this.account_id = this.account;
    } else {
      this.account_id = localStorage.getItem('account');
    }
    this.route.queryParams
        .subscribe(params => {
          this.JSSnippet = '';
          this.curlSnippet = '';
          this.JavaSnippet = '';
          this.PySnippet = '';
          this.NodeSnippet = '';
          this.RubySnippet = '';
          this.GoSnippet = '';
          this.getRequest = '';
          this.getResponse = null;
          this.getDevex();
          if (params.entity && params.version) {
          this.entity = params.entity;
          this.version = params.version;
          if (this.entity === undefined) {
            if (this.Entity !== undefined) {
              this.entity = this.Entity;
            }
          }
        }
        });
    this.environmentHeaders = environment.headersDescription;
  }

  async ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        switch (propName) {
          case 'operations':
            this.operationsActions = [];
            for (const operation of this.operations) {
              const displayName = operation['executor_display_name'] && operation['executor_display_name'] !== '' ? operation['executor_display_name'] : operation['executor_name'];
              this.operationsActions.push({expanded: true, edit_executor_display_name: false, display_name: displayName});
            }
            break;
          default:
            break;
        }
      }
    }
  }

  toggleExecutor(ev) {
    $('.more-query-options').slideToggle();
    this.isExpanded = !this.isExpanded;
    // $(ev.target).toggleClass('fa-chevron-down fa-chevron-up');
  }

  hasExecutorExecutePermission(partner, account, operation) {
    if (operation['executor_type'] === 'API') {
      return this.platform.hasPermissions(['EXECUTE_API_DOCUMENTATION', 'execute_api_documentation:' + partner + '=>' + account + '=>' + operation['executor_category'] + '=>' + operation['executor_version']]);
    } else {
      return this.platform.hasPermissions(['EXECUTE_API_DOCUMENTATION', 'execute_api_documentation:' + partner + '=>' + account + '=>' + operation['executor_name'] + '=>' + operation['executor_version']]);
    }
  }

  checkBulkInsert(operation) {
    if (operation.executor_name.search('post-bulkinsert') !== -1) {
      return true;
    }
  }

  isMap(obj) {
    return Object.prototype.toString.call(obj) === '[object Map]';
  }

  setLanguageSnippets() {
    this.languageSnippets = this.languages.map((language) => {
      switch (language.value) {
        case 'curl':
          return { ...language, code: this.curlSnippet };
        case 'goNative':
          return { ...language, code: this.GoSnippet };
        case 'js':
          return { ...language, code: this.JSSnippet };
        case 'java':
          return { ...language, code: this.JavaSnippet };
        case 'node':
          return { ...language, code: this.NodeSnippet };
        case 'python':
          return { ...language, code: this.PySnippet };
        case 'ruby':
          return { ...language, code: this.RubySnippet };
        default:
          return language;
      }
    });
  }

  getDevex() {
    this.confPost.getEntity(this.partnerKey, this.account_id, this.entity, this.version).subscribe(items => {
      if (items) {
        this.dataSource = items['attributes'];
        this.getDataModel();
      }
    });
    // if (this.operations[0]['executor_method_type'] === 'GET') {
    //   this.JSSnippet = 'var settings = {\n';
    //   this.JSSnippet = this.JSSnippet + '\"url\":\"' + this.operations[0]['apiUrl'] + '\",\n';
    //   this.JSSnippet = this.JSSnippet + '\"method\": \"GET\",\n';
    //   this.JSSnippet = this.JSSnippet + '\"timeout\": 0,\n';
    //   this.JSSnippet = this.JSSnippet + '\"headers\": {\n';
    //   for (const parameter of this.operations[0]['headers']) {
    //     this.JSSnippet = this.JSSnippet + '\"' + parameter['key'] + '\" : \"' + parameter['value'] + '\",\n';
    //   }
    //   this.JSSnippet = this.JSSnippet + '},\n';
    //   this.JSSnippet = this.JSSnippet + '};\n';
    //   this.JSSnippet = this.JSSnippet + '$.ajax(settings).done(function (response) {';
    //   this.JSSnippet = this.JSSnippet + 'console.log(response);';
    //   this.JSSnippet = this.JSSnippet + '});\n';
    //
    //   this.curlSnippet = 'curl --location --request GET \"' + this.operations[0]['apiUrl'] + '\"';
    //   for (const parameter of this.operations[0]['headers']) {
    //     this.curlSnippet = this.curlSnippet + '--header \'' + parameter['key'] + ':' + parameter['value'] + '\'\\';
    //   }
    //
    //
    //   this.JavaSnippet = 'OkHttpClient client = new OkHttpClient().newBuilder().build();\n';
    //   this.JavaSnippet = this.JavaSnippet + 'Request request = new Request.Builder()\n';
    //   this.JavaSnippet = this.JavaSnippet + '.url(\"' + this.operations[0]['apiUrl'] + '\")\n';
    //   this.JavaSnippet = this.JavaSnippet + '.method(\"GET\", null)\n';
    //   for (const parameter of this.operations[0]['headers']) {
    //     this.JavaSnippet = this.JavaSnippet + '.addHeader(\"' + parameter['key'] + '\" , \"' + parameter['value'] + '\")\n';
    //   }
    //   this.JavaSnippet = this.JavaSnippet + '.build();\n';
    //   this.JavaSnippet = this.JavaSnippet + 'Response response = call.newCall(request).execute();';
    //
    //   // this.PySnippet = 'OkHttpClient client = new OkHttpClient().newBuilder().build();\n';
    //   this.PySnippet = 'import http.client\n';
    //   this.PySnippet = this.PySnippet + 'import mimetypes\n';
    //   this.PySnippet = this.PySnippet + 'conn = http.client.HTTPSConnection("")\n';
    //   this.PySnippet = this.PySnippet + 'payload = \'\'\n';
    //   this.PySnippet = this.PySnippet + 'headers = {';
    //   for (const parameter of this.operations[0]['headers']) {
    //     this.PySnippet = this.PySnippet + '\'' + parameter['key'] + '\' : \'' + parameter['value'] + '\'\n';
    //   }
    //   this.PySnippet = this.PySnippet + '}\n';
    //   this.PySnippet = this.PySnippet + 'conn.request("GET", "' + this.operations[0]['apiUrl'] + '", payload, headers)\n';
    //   this.PySnippet = this.PySnippet + 'res = conn.getresponse()\n';
    //   this.PySnippet = this.PySnippet + 'data = res.read()\n';
    //   this.PySnippet = this.PySnippet + 'print(data.decode("utf-8"))\n';
    //
    //   this.NodeSnippet = 'var request = require(\'request\');\n';
    //   this.NodeSnippet = this.NodeSnippet + 'var options = {\n';
    //   this.NodeSnippet = this.NodeSnippet + '\'method\': \'GET\',\n';
    //   this.NodeSnippet = this.NodeSnippet + '\'url\': \'' + this.operations[0]['apiUrl'] + '\',\n';
    //   this.NodeSnippet = this.NodeSnippet + '\'headers\': {\n';
    //   for (const parameter of this.operations[0]['headers']) {
    //     this.NodeSnippet = this.NodeSnippet + '\'' + parameter['key'] + '\' : \'' + parameter['value'] + '\',\n';
    //   }
    //   this.NodeSnippet = this.NodeSnippet + '}\n';
    //   this.NodeSnippet = this.NodeSnippet + '};\n';
    //   this.NodeSnippet = this.NodeSnippet + 'request(options, function (error, response) {\n';
    //   this.NodeSnippet = this.NodeSnippet + 'if (error) throw new Error(error);\n';
    //   this.NodeSnippet = this.NodeSnippet + 'console.log(response.body);\n';
    //   this.NodeSnippet = this.NodeSnippet + '});\n';
    //
    //   this.GoSnippet = 'package main\n';
    //   this.GoSnippet = this.GoSnippet + 'import (\n';
    //   this.GoSnippet = this.GoSnippet + '\"fmt\"\n';
    //   this.GoSnippet = this.GoSnippet + '\"net/http\"\n';
    //   this.GoSnippet = this.GoSnippet + '\"io/ioutil\"\n';
    //   this.GoSnippet = this.GoSnippet + ')\n';
    //   this.GoSnippet = this.GoSnippet + 'func main() {\n';
    //   this.GoSnippet = this.GoSnippet + 'url := \"' + this.operations[0]['apiUrl'] + '\"\n';
    //   this.GoSnippet = this.GoSnippet + 'method := \"GET\"\n';
    //   this.GoSnippet = this.GoSnippet + 'client := \&http.Client {\n';
    //   this.GoSnippet = this.GoSnippet + '}\n';
    //   this.GoSnippet = this.GoSnippet + 'req, err := http.NewRequest(method, url, nil)\n';
    //   this.GoSnippet = this.GoSnippet + 'if err!= nil {\n';
    //   this.GoSnippet = this.GoSnippet + 'fmt.Println(err)\n';
    //   this.GoSnippet = this.GoSnippet + '}\n';
    //   for (const parameter of this.operations[0]['headers']) {
    //     this.GoSnippet = this.GoSnippet + 'req.Header.Add(\"' + parameter['key'] + '\", \"' + parameter['value'] + '\")\n';
    //   }
    //   this.GoSnippet = this.GoSnippet + 'res, err := client.Do(req)\n';
    //   this.GoSnippet = this.GoSnippet + 'defer res.Body.Close()\n';
    //   this.GoSnippet = this.GoSnippet + 'body, err := ioutil.ReadAll(res.Body)\n';
    //   this.GoSnippet = this.GoSnippet + 'fmt.Println(string(body))\n';
    //   this.GoSnippet = this.GoSnippet + '}\n';
    //
    //   this.RubySnippet = 'require \"uri\"\n';
    //   this.RubySnippet = this.RubySnippet + 'require \"net/http\"\n';
    //   this.RubySnippet = this.RubySnippet + 'url = URI(\"' + this.operations[0]['apiUrl'] + '\")\n';
    //   this.RubySnippet = this.RubySnippet + 'http = Net::HTTP.new(url.host, url.port);\n';
    //   this.RubySnippet = this.RubySnippet + 'request = Net::HTTP::Get.new(url)\n';
    //   for (const parameter of this.operations[0]['headers']) {
    //     this.RubySnippet = this.RubySnippet + 'request[\"' + parameter['key'] + '\" = \"' + parameter['value'] + '\"\n';
    //   }
    //   this.RubySnippet = this.RubySnippet + 'response = http.request(request)\n';
    //   this.RubySnippet = this.RubySnippet + 'puts response.read_body';
    // } else if (this.operations[0]['executor_method_type'] === 'PUT') {
    //   this.curlSnippet = 'curl --location --request PUT \'' + this.operations[0]['apiUrl'] + '\'\'';
    //   for (const parameter of this.operations[0]['headers']) {
    //     this.curlSnippet = this.curlSnippet + '--header \'' + parameter['key'] + ':' + parameter['value'] + '\'\\';
    //   }
    //
    //   this.JSSnippet = 'var setting = {\n';
    //   this.JSSnippet = this.JSSnippet + '\"url\":\"' + this.operations[0]['apiUrl'] + '\",\n';
    //   this.JSSnippet = this.JSSnippet + '\"method\": \"PUT\",\n';
    //   this.JSSnippet = this.JSSnippet + '\"timeout\": 0,\n';
    //   this.JSSnippet = this.JSSnippet + '\"headers\": {\n';
    //   for (const parameter of this.operations[0]['headers']) {
    //     this.JSSnippet = this.JSSnippet + '\"' + parameter['key'] + '\" : \"' + parameter['value'] + '\",\n';
    //   }
    //   this.JSSnippet = this.JSSnippet + '},\n';
    //   this.JSSnippet = this.JSSnippet + '};\n';
    //   this.JSSnippet = this.JSSnippet + '$.ajax(settings).done(function (response) {';
    //   this.JSSnippet = this.JSSnippet + 'console.log(response);';
    //   this.JSSnippet = this.JSSnippet + '});\n';
    //
    //   this.JavaSnippet = 'OkHttpClient client = new OkHttpClient().newBuilder().build();\n';
    //   this.JavaSnippet = this.JavaSnippet + 'MediaType mediaType = MediaType.parse(\"text/plain\")\n';
    //   this.JavaSnippet = this.JavaSnippet + 'RequestBody body = RequestBody.create(mediaType, \"\")\n';
    //   this.JavaSnippet = this.JavaSnippet + 'Request request = new Request.Builder()\n';
    //   this.JavaSnippet = this.JavaSnippet + '.url(\"' + this.operations[0]['apiUrl'] + '\")\n';
    //   this.JavaSnippet = this.JavaSnippet + '.method(\"PUT\", null)\n';
    //   for (const parameter of this.operations[0]['headers']) {
    //     this.JavaSnippet = this.JavaSnippet + '.addHeader(\"' + parameter['key'] + '\" , \"' + parameter['value'] + '\")\n';
    //   }
    //   this.JavaSnippet = this.JavaSnippet + '.build();\n';
    //   this.JavaSnippet = this.JavaSnippet + 'Response response = call.newCall(request).execute();';
    //
    //   this.GoSnippet = 'package main\n';
    //   this.GoSnippet = this.GoSnippet + 'import (\n';
    //   this.GoSnippet = this.GoSnippet + '\"fmt\"\n';
    //   this.GoSnippet = this.GoSnippet + '\"net/http\"\n';
    //   this.GoSnippet = this.GoSnippet + '\"io/ioutil\"\n';
    //   this.GoSnippet = this.GoSnippet + ')\n';
    //   this.GoSnippet = this.GoSnippet + 'func main() {\n';
    //   this.GoSnippet = this.GoSnippet + 'url := \"' + this.operations[0]['apiUrl'] + '\"\n';
    //   this.GoSnippet = this.GoSnippet + 'method := \"PUT\"\n';
    //   this.GoSnippet = this.GoSnippet + 'client := \&http.Client {\n';
    //   this.GoSnippet = this.GoSnippet + '}\n';
    //   this.GoSnippet = this.GoSnippet + 'req, err := http.NewRequest(method, url, nil)\n';
    //   this.GoSnippet = this.GoSnippet + 'if err!= nil {\n';
    //   this.GoSnippet = this.GoSnippet + 'fmt.Println(err)\n';
    //   this.GoSnippet = this.GoSnippet + '}\n';
    //   for (const parameter of this.operations[0]['headers']) {
    //     this.GoSnippet = this.GoSnippet + 'req.Header.Add(\"' + parameter['key'] + '\", \"' + parameter['value'] + '\")\n';
    //   }
    //   this.GoSnippet = this.GoSnippet + 'res, err := client.Do(req)\n';
    //   this.GoSnippet = this.GoSnippet + 'defer res.Body.Close()\n';
    //   this.GoSnippet = this.GoSnippet + 'body, err := ioutil.ReadAll(res.Body)\n';
    //   this.GoSnippet = this.GoSnippet + 'fmt.Println(string(body))\n';
    //   this.GoSnippet = this.GoSnippet + '}\n';
    //
    //   this.PySnippet = 'import http.client\n';
    //   this.PySnippet = this.PySnippet + 'import mimetypes\n';
    //   this.PySnippet = this.PySnippet + 'conn = http.client.HTTPSConnection("")\n';
    //   this.PySnippet = this.PySnippet + 'payload = \'\'\n';
    //   this.PySnippet = this.PySnippet + 'headers = {';
    //   for (const parameter of this.operations[0]['headers']) {
    //     this.PySnippet = this.PySnippet + '\'' + parameter['key'] + '\' : \'' + parameter['value'] + '\'\n';
    //   }
    //   this.PySnippet = this.PySnippet + '}\n';
    //   this.PySnippet = this.PySnippet + 'conn.request("PUT", "' + this.operations[0]['apiUrl'] + '", payload, headers)\n';
    //   this.PySnippet = this.PySnippet + 'res = conn.getresponse()\n';
    //   this.PySnippet = this.PySnippet + 'data = res.read()\n';
    //   this.PySnippet = this.PySnippet + 'print(data.decode("utf-8"))\n';
    //
    //   this.NodeSnippet = 'var request = require(\'request\');\n';
    //   this.NodeSnippet = this.NodeSnippet + 'var options = {\n';
    //   this.NodeSnippet = this.NodeSnippet + '\'method\': \'PUT\',\n';
    //   this.NodeSnippet = this.NodeSnippet + '\'url\': \'' + this.operations[0]['apiUrl'] + '\',\n';
    //   this.NodeSnippet = this.NodeSnippet + '\'headers\': {\n';
    //   for (const parameter of this.operations[0]['headers']) {
    //     this.NodeSnippet = this.NodeSnippet + '\'' + parameter['key'] + '\' : \'' + parameter['value'] + '\',\n';
    //   }
    //   this.NodeSnippet = this.NodeSnippet + '}\n';
    //   this.NodeSnippet = this.NodeSnippet + '};\n';
    //   this.NodeSnippet = this.NodeSnippet + 'request(options, function (error, response) {\n';
    //   this.NodeSnippet = this.NodeSnippet + 'if (error) throw new Error(error);\n';
    //   this.NodeSnippet = this.NodeSnippet + 'console.log(response.body);\n';
    //   this.NodeSnippet = this.NodeSnippet + '});\n';
    //
    //   this.RubySnippet = 'require \"uri\"\n';
    //   this.RubySnippet = this.RubySnippet + 'require \"net/http\"\n';
    //   this.RubySnippet = this.RubySnippet + 'url = URI(\"' + this.operations[0]['apiUrl'] + '\")\n';
    //   this.RubySnippet = this.RubySnippet + 'http = Net::HTTP.new(url.host, url.port);\n';
    //   this.RubySnippet = this.RubySnippet + 'request = Net::HTTP::Post.new(url)\n';
    //   for (const parameter of this.operations[0]['headers']) {
    //     this.RubySnippet = this.RubySnippet + 'request[\"' + parameter['key'] + '\" = \"' + parameter['value'] + '\"\n';
    //   }
    //   this.RubySnippet = this.RubySnippet + 'response = http.request(request)\n';
    //   this.RubySnippet = this.RubySnippet + 'puts response.read_body';
    // } else if (this.operations[0]['executor_method_type'] === 'POST') {
    //   this.curlSnippet = 'curl --location --request POST \"' + this.operations[0]['apiUrl'] + '\"';
    //   for (const parameter of this.operations[0]['headers']) {
    //     this.curlSnippet = this.curlSnippet + '--header \'' + parameter['key'] + ':' + parameter['value'] + '\'\\';
    //   }
    //
    //   this.JSSnippet = 'var settings = {\n';
    //   this.JSSnippet = this.JSSnippet + '\"url\":\"' + this.operations[0]['apiUrl'] + '\",\n';
    //   this.JSSnippet = this.JSSnippet + '\"method\": \"POST\",\n';
    //   this.JSSnippet = this.JSSnippet + '\"timeout\": 0,\n';
    //   this.JSSnippet = this.JSSnippet + '\"headers\": {\n';
    //   for (const parameter of this.operations[0]['headers']) {
    //     this.JSSnippet = this.JSSnippet + '\"' + parameter['key'] + '\" : \"' + parameter['value'] + '\",\n';
    //   }
    //   this.JSSnippet = this.JSSnippet + '},\n';
    //   this.JSSnippet = this.JSSnippet + '};\n';
    //   this.JSSnippet = this.JSSnippet + '$.ajax(settings).done(function (response) {';
    //   this.JSSnippet = this.JSSnippet + 'console.log(response);';
    //   this.JSSnippet = this.JSSnippet + '});\n';
    //
    //   this.JavaSnippet = 'OkHttpClient client = new OkHttpClient().newBuilder().build();\n';
    //   this.JavaSnippet = this.JavaSnippet + 'MediaType mediaType = MediaType.parse(\"text/plain\")\n';
    //   this.JavaSnippet = this.JavaSnippet + 'RequestBody body = RequestBody.create(mediaType, \"\")\n';
    //   this.JavaSnippet = this.JavaSnippet + 'Request request = new Request.Builder()\n';
    //   this.JavaSnippet = this.JavaSnippet + '.url(\"' + this.operations[0]['apiUrl'] + '\")\n';
    //   this.JavaSnippet = this.JavaSnippet + '.method(\"POST\", null)\n';
    //   for (const parameter of this.operations[0]['headers']) {
    //     this.JavaSnippet = this.JavaSnippet + '.addHeader(\"' + parameter['key'] + '\" , \"' + parameter['value'] + '\")\n';
    //   }
    //   this.JavaSnippet = this.JavaSnippet + '.build();\n';
    //   this.JavaSnippet = this.JavaSnippet + 'Response response = call.newCall(request).execute();';
    //
    //   this.GoSnippet = 'package main\n';
    //   this.GoSnippet = this.GoSnippet + 'import (\n';
    //   this.GoSnippet = this.GoSnippet + '\"fmt\"\n';
    //   this.GoSnippet = this.GoSnippet + '\"net/http\"\n';
    //   this.GoSnippet = this.GoSnippet + '\"io/ioutil\"\n';
    //   this.GoSnippet = this.GoSnippet + ')\n';
    //   this.GoSnippet = this.GoSnippet + 'func main() {\n';
    //   this.GoSnippet = this.GoSnippet + 'url := \"' + this.operations[0]['apiUrl'] + '\"\n';
    //   this.GoSnippet = this.GoSnippet + 'method := \"POST\"\n';
    //   this.GoSnippet = this.GoSnippet + 'client := \&http.Client {\n';
    //   this.GoSnippet = this.GoSnippet + '}\n';
    //   this.GoSnippet = this.GoSnippet + 'req, err := http.NewRequest(method, url, nil)\n';
    //   this.GoSnippet = this.GoSnippet + 'if err!= nil {\n';
    //   this.GoSnippet = this.GoSnippet + 'fmt.Println(err)\n';
    //   this.GoSnippet = this.GoSnippet + '}\n';
    //   for (const parameter of this.operations[0]['headers']) {
    //     this.GoSnippet = this.GoSnippet + 'req.Header.Add(\"' + parameter['key'] + '\", \"' + parameter['value'] + '\")\n';
    //   }
    //   this.GoSnippet = this.GoSnippet + 'res, err := client.Do(req)\n';
    //   this.GoSnippet = this.GoSnippet + 'defer res.Body.Close()\n';
    //   this.GoSnippet = this.GoSnippet + 'body, err := ioutil.ReadAll(res.Body)\n';
    //   this.GoSnippet = this.GoSnippet + 'fmt.Println(string(body))\n';
    //   this.GoSnippet = this.GoSnippet + '}\n';
    //
    //   this.PySnippet = 'import http.client\n';
    //   this.PySnippet = this.PySnippet + 'import mimetypes\n';
    //   this.PySnippet = this.PySnippet + 'conn = http.client.HTTPSConnection("")\n';
    //   this.PySnippet = this.PySnippet + 'payload = \'\'\n';
    //   this.PySnippet = this.PySnippet + 'headers = {';
    //   for (const parameter of this.operations[0]['headers']) {
    //     this.PySnippet = this.PySnippet + '\'' + parameter['key'] + '\' : \'' + parameter['value'] + '\'\n';
    //   }
    //   this.PySnippet = this.PySnippet + '}\n';
    //   this.PySnippet = this.PySnippet + 'conn.request("POST", "' + this.operations[0]['apiUrl'] + '", payload, headers)\n';
    //   this.PySnippet = this.PySnippet + 'res = conn.getresponse()\n';
    //   this.PySnippet = this.PySnippet + 'data = res.read()\n';
    //   this.PySnippet = this.PySnippet + 'print(data.decode("utf-8"))\n';
    //
    //   this.NodeSnippet = 'var request = require(\'request\');\n';
    //   this.NodeSnippet = this.NodeSnippet + 'var options = {\n';
    //   this.NodeSnippet = this.NodeSnippet + '\'method\': \'POST\',\n';
    //   this.NodeSnippet = this.NodeSnippet + '\'url\': \'' + this.operations[0]['apiUrl'] + '\',\n';
    //   this.NodeSnippet = this.NodeSnippet + '\'headers\': {\n';
    //   for (const parameter of this.operations[0]['headers']) {
    //     this.NodeSnippet = this.NodeSnippet + '\'' + parameter['key'] + '\' : \'' + parameter['value'] + '\',\n';
    //   }
    //   this.NodeSnippet = this.NodeSnippet + '}\n';
    //   this.NodeSnippet = this.NodeSnippet + '};\n';
    //   this.NodeSnippet = this.NodeSnippet + 'request(options, function (error, response) {\n';
    //   this.NodeSnippet = this.NodeSnippet + 'if (error) throw new Error(error);\n';
    //   this.NodeSnippet = this.NodeSnippet + 'console.log(response.body);\n';
    //   this.NodeSnippet = this.NodeSnippet + '});\n';
    //
    //   this.RubySnippet = 'require \"uri\"\n';
    //   this.RubySnippet = this.RubySnippet + 'require \"net/http\"\n';
    //   this.RubySnippet = this.RubySnippet + 'url = URI(\"' + this.operations[0]['apiUrl'] + '\")\n';
    //   this.RubySnippet = this.RubySnippet + 'http = Net::HTTP.new(url.host, url.port);\n';
    //   this.RubySnippet = this.RubySnippet + 'request = Net::HTTP::Post.new(url)\n';
    //   for (const parameter of this.operations[0]['headers']) {
    //     this.RubySnippet = this.RubySnippet + 'request[\"' + parameter['key'] + '\" = \"' + parameter['value'] + '\"\n';
    //   }
    //   this.RubySnippet = this.RubySnippet + 'response = http.request(request)\n';
    //   this.RubySnippet = this.RubySnippet + 'puts response.read_body';
    // } else if (this.operations[0]['executor_method_type'] === 'DELETE') {
    //
    //   this.curlSnippet = 'curl --location --request DELETE \'' + this.operations[0]['apiUrl'] + '\'\'';
    //   for (const parameter of this.operations[0]['headers']) {
    //     this.curlSnippet = this.curlSnippet + '--header \'' + parameter['key'] + ':' + parameter['value'] + '\'\\';
    //   }
    //
    //   this.JavaSnippet = 'OkHttpClient client = new OkHttpClient().newBuilder().build();\n';
    //   this.JavaSnippet = this.JavaSnippet + 'MediaType mediaType = MediaType.parse(\"text/plain\")\n';
    //   this.JavaSnippet = this.JavaSnippet + 'RequestBody body = RequestBody.create(mediaType, \"\")\n';
    //   this.JavaSnippet = this.JavaSnippet + 'Request request = new Request.Builder()\n';
    //   this.JavaSnippet = this.JavaSnippet + '.url(\"' + this.operations[0]['apiUrl'] + '\")\n';
    //   this.JavaSnippet = this.JavaSnippet + '.method(\"DELETE\", null)\n';
    //   for (const parameter of this.operations[0]['headers']) {
    //     this.JavaSnippet = this.JavaSnippet + '.addHeader(\"' + parameter['key'] + '\" , \"' + parameter['value'] + '\")\n';
    //   }
    //   this.JavaSnippet = this.JavaSnippet + '.build();\n';
    //   this.JavaSnippet = this.JavaSnippet + 'Response response = call.newCall(request).execute();';
    //
    //   this.JSSnippet = 'var settings = {\n';
    //   this.JSSnippet = this.JSSnippet + '\"url\":\"' + this.operations[0]['apiUrl'] + '\",\n';
    //   this.JSSnippet = this.JSSnippet + '\"method\": \"DELETE\",\n';
    //   this.JSSnippet = this.JSSnippet + '\"timeout\": 0,\n';
    //   this.JSSnippet = this.JSSnippet + '\"headers\": {\n';
    //   for (const parameter of this.operations[0]['headers']) {
    //     this.JSSnippet = this.JSSnippet + '\"' + parameter['key'] + '\" : \"' + parameter['value'] + '\",\n';
    //   }
    //   this.JSSnippet = this.JSSnippet + '},\n';
    //   this.JSSnippet = this.JSSnippet + '};\n';
    //   this.JSSnippet = this.JSSnippet + '$.ajax(settings).done(function (response) {';
    //   this.JSSnippet = this.JSSnippet + 'console.log(response);';
    //   this.JSSnippet = this.JSSnippet + '});\n';
    //
    //   this.NodeSnippet = 'var request = require(\'request\');\n';
    //   this.NodeSnippet = this.NodeSnippet + 'var options = {\n';
    //   this.NodeSnippet = this.NodeSnippet + '\'method\': \'DELETE\',\n';
    //   this.NodeSnippet = this.NodeSnippet + '\'url\': \'' + this.operations[0]['apiUrl'] + '\',\n';
    //   this.NodeSnippet = this.NodeSnippet + '\'headers\': {\n';
    //   for (const parameter of this.operations[0]['headers']) {
    //     this.NodeSnippet = this.NodeSnippet + '\'' + parameter['key'] + '\' : \'' + parameter['value'] + '\',\n';
    //   }
    //   this.NodeSnippet = this.NodeSnippet + '}\n';
    //   this.NodeSnippet = this.NodeSnippet + '};\n';
    //   this.NodeSnippet = this.NodeSnippet + 'request(options, function (error, response) {\n';
    //   this.NodeSnippet = this.NodeSnippet + 'if (error) throw new Error(error);\n';
    //   this.NodeSnippet = this.NodeSnippet + 'console.log(response.body);\n';
    //   this.NodeSnippet = this.NodeSnippet + '});\n';
    //
    //   this.GoSnippet = 'package main\n';
    //   this.GoSnippet = this.GoSnippet + 'import (\n';
    //   this.GoSnippet = this.GoSnippet + '\"fmt\"\n';
    //   this.GoSnippet = this.GoSnippet + '\"net/http\"\n';
    //   this.GoSnippet = this.GoSnippet + '\"io/ioutil\"\n';
    //   this.GoSnippet = this.GoSnippet + ')\n';
    //   this.GoSnippet = this.GoSnippet + 'func main() {\n';
    //   this.GoSnippet = this.GoSnippet + 'url := \"' + this.operations[0]['apiUrl'] + '\"\n';
    //   this.GoSnippet = this.GoSnippet + 'method := \"DELETE\"\n';
    //   this.GoSnippet = this.GoSnippet + 'client := \&http.Client {\n';
    //   this.GoSnippet = this.GoSnippet + '}\n';
    //   this.GoSnippet = this.GoSnippet + 'req, err := http.NewRequest(method, url, nil)\n';
    //   this.GoSnippet = this.GoSnippet + 'if err!= nil {\n';
    //   this.GoSnippet = this.GoSnippet + 'fmt.Println(err)\n';
    //   this.GoSnippet = this.GoSnippet + '}\n';
    //   for (const parameter of this.operations[0]['headers']) {
    //     this.GoSnippet = this.GoSnippet + 'req.Header.Add(\"' + parameter['key'] + '\", \"' + parameter['value'] + '\")\n';
    //   }
    //   this.GoSnippet = this.GoSnippet + 'res, err := client.Do(req)\n';
    //   this.GoSnippet = this.GoSnippet + 'defer res.Body.Close()\n';
    //   this.GoSnippet = this.GoSnippet + 'body, err := ioutil.ReadAll(res.Body)\n';
    //   this.GoSnippet = this.GoSnippet + 'fmt.Println(string(body))\n';
    //   this.GoSnippet = this.GoSnippet + '}\n';
    //
    //   this.PySnippet = 'import http.client\n';
    //   this.PySnippet = this.PySnippet + 'import mimetypes\n';
    //   this.PySnippet = this.PySnippet + 'conn = http.client.HTTPSConnection("")\n';
    //   this.PySnippet = this.PySnippet + 'payload = \'\'\n';
    //   this.PySnippet = this.PySnippet + 'headers = {';
    //   for (const parameter of this.operations[0]['headers']) {
    //     this.PySnippet = this.PySnippet + '\'' + parameter['key'] + '\' : \'' + parameter['value'] + '\'\n';
    //   }
    //   this.PySnippet = this.PySnippet + '}\n';
    //   this.PySnippet = this.PySnippet + 'conn.request("DELETE", "' + this.operations[0]['apiUrl'] + '", payload, headers)\n';
    //   this.PySnippet = this.PySnippet + 'res = conn.getresponse()\n';
    //   this.PySnippet = this.PySnippet + 'data = res.read()\n';
    //   this.PySnippet = this.PySnippet + 'print(data.decode("utf-8"))\n';
    //
    //   this.RubySnippet = 'require \"uri\"\n';
    //   this.RubySnippet = this.RubySnippet + 'require \"net/http\"\n';
    //   this.RubySnippet = this.RubySnippet + 'url = URI(\"' + this.operations[0]['apiUrl'] + '\")\n';
    //   this.RubySnippet = this.RubySnippet + 'http = Net::HTTP.new(url.host, url.port);\n';
    //   this.RubySnippet = this.RubySnippet + 'request = Net::HTTP::Delete.new(url)\n';
    //   for (const parameter of this.operations[0]['headers']) {
    //     this.RubySnippet = this.RubySnippet + 'request[\"' + parameter['key'] + '\" = \"' + parameter['value'] + '\"\n';
    //   }
    //   this.RubySnippet = this.RubySnippet + 'response = http.request(request)\n';
    //   this.RubySnippet = this.RubySnippet + 'puts response.read_body';
    // }
    this.generateCodeSnippets();
    this.setLanguageSnippets();
  }

  generateCodeSnippets() {
    this.getCurlCodeSnippet();
    this.getJsCodeSnippet();
    this.getNodeJSCodeSnippet();
    this.getRubyCodeSnippet();
    this.getPythonCodeSnippet();
    this.getGoCodeSnippet();
    this.getJavaSnippet();
  }

  getNodeJSCodeSnippet() {
    let url: string = this.operations[0]['apiUrl'];
    const host: any = this.operations[0]['apiUrl'].split('://')[1].split('/')[0];
    url = url.split(/\/[{:]|\/:/)[0];

    if (this.isNotEmpty(this.operations[0]['pathParams'])) {
      for (const path of this.operations[0]['pathParams']) {
        url += `/${path['value']}`;
      }
    }

    const headers = {};
    if (this.operations[0]['headers']) {
      for (const header of this.operations[0]['headers']) {
        headers[header['key']] = header['value'];
      }
    }

    let requestCallSnippet = '';
    const queryParams = {};
    let paramSnippet = '';
    if (this.isNotEmpty(this.operations[0]['queryParams'])) {
      for (const qp of this.operations[0]['queryParams']) {
        queryParams[qp['key']] = qp['value'];
      }
      paramSnippet = `const params = ${JSON.stringify(queryParams)};\n`;
    }

    const params = {
      url: url,
      method: this.operations[0]['executor_method_type'],
      headers: {}
    };

    let body = {};
    if (this.operations[0]['requestBody'] !== null && this.operations[0]['requestBody'] !== undefined) {
      if (this.operations[0]['requestBody']['value'] !== undefined && this.operations[0]['requestBody']['value'] !== null) {
        const requestBodyValue = this.operations[0]['requestBody']['value'];
        if (Array.isArray(requestBodyValue)) {
          for (const rqb of requestBodyValue) {
            body[rqb['key']] = rqb['value'];
          }
        } else {
          body = this.operations[0]['requestBody']['value'];
        }
      }
    }

    let payload = {};
    let payloadSnippet = '';

    if (Object.keys(body).length > 0) {
      if (headers['Content-Type'] === 'application/json') {
        payload = JSON.stringify(body);
        payloadSnippet = `const payload = JSON.stringify(${payload});\n`;
      } else if (headers['Content-Type'] === 'application/x-www-form-urlencoded') {
        payload = body;
        payloadSnippet = `const payload = ${JSON.stringify(payload)};\n`;
      } else if (headers['Content-Type'] === 'multipart/form-data') {
        // delete headers['Content-Type'];
        // const formData = new FormData();
        // for (const key in body) {
        //     if (body.hasOwnProperty(key)) {
        //         formData.append(key, body[key]);
        //     }
        // }
        payload = body;
        payloadSnippet = `const payload = ${JSON.stringify(payload)};\n`;
      } else {
        payload = body;
        payloadSnippet = `const payload = ${payload};\n`;
      }
    }

    if (Object.keys(queryParams).length > 0 && Object.keys(payload).length > 0) {
      requestCallSnippet = `(url, payload, { params, headers })`;
    } else if (Object.keys(queryParams).length > 0 && Object.keys(payload).length === 0) {
      requestCallSnippet = `(url, { params, headers })`;
    } else if (Object.keys(queryParams).length === 0 && Object.keys(payload).length > 0) {
      requestCallSnippet = `(url, payload, { headers })`;
    }

    this.NodeSnippet = `const axios = require('axios');
const url = "${url}";
const headers = ${JSON.stringify(headers)};
${paramSnippet}${payloadSnippet}axios.${params.method.toLowerCase()}${requestCallSnippet}
  .then(response => {
    console.log(response.data);
  })
  .catch(error => {
    console.error(error);
  });`;
  }


  getRubyCodeSnippet(): void {
    let url: string = this.operations[0]['apiUrl'];
    const host: any = this.operations[0]['apiUrl'].split('://')[1].split('/')[0];
    url = url.split(/\/[{:]|\/:/)[0];

    if (this.operations[0]['pathParams'] !== undefined && this.operations[0]['pathParams'] !== null) {
      for (const path of this.operations[0]['pathParams']) {
        url += `/${path['value']}`;
      }
    }
    let headers = {};
    if (this.operations[0]['headers']) {
      for (const header of this.operations[0]['headers']) {
        headers[header['key']] = header['value'];
      }
    }
    headers = JSON.parse(JSON.stringify(headers));

    let requestCallSnippet = '';
    const queryParams = {};
    let paramSnippet = '';
    if (this.operations[0]['queryParams'] !== undefined && this.operations[0]['queryParams'] !== null && this.operations[0]['queryParams'].length > 0) {
      for (const qp of this.operations[0]['queryParams']) {
        queryParams[qp['key']] = qp['value'];
      }
      paramSnippet = `params = ${JSON.stringify(queryParams)}\n`;
    }

    const params = {
      url: url,
      method: this.operations[0]['executor_method_type'],
      headers: {}
    };

    let body = {};
    if (this.operations[0]['requestBody'] !== null && this.operations[0]['requestBody'] !== undefined) {
      if (this.operations[0]['requestBody']['value'] !== undefined && this.operations[0]['requestBody']['value'] !== null) {
        const requestBodyValue = this.operations[0]['requestBody']['value'];
        if (Array.isArray(requestBodyValue)) {
          for (const rqb of requestBodyValue) {
            body[rqb['key']] = rqb['value'];
          }
        } else {
          body = this.operations[0]['requestBody']['value'];
        }
      }
    }

    let payload = {};
    let payloadSnippet = '';

    if (Object.keys(body).length > 0) {
      if (headers['Content-Type'] === 'application/json') {
        payload = JSON.stringify(body);
        payloadSnippet = `payload = ${payload}.to_json`;
        requestCallSnippet = `request.body = payload`;
      } else if (headers['Content-Type'] === 'application/x-www-form-urlencoded') {
        payload = body;
        payloadSnippet = `payload = ${JSON.stringify(payload)}`;
        requestCallSnippet = `request.set_form_data(payload)`;
      } else if (headers['Content-Type'] === 'multipart/form-data') {
        delete headers['Content-Type'];
        // const formData = new FormData();
        // for (const key in body) {
        //     if (body.hasOwnProperty(key)) {
        //         formData.append(key, body[key]);
        //     }
        // }
        payload = body;
        payloadSnippet = `payload = ${JSON.stringify(payload)}\n`;
        requestCallSnippet = `request.set_form_data(payload)`;
      } else {
        payload = body;
        payloadSnippet = `payload = ${JSON.stringify(payload)}\n`;
        requestCallSnippet = `request.body = payload`;
      }
    }

    let uriInitializationSnippet = '';
    if (Object.keys(queryParams).length > 0) {
      uriInitializationSnippet = `uri = URI.parse(url)\nuri.query = URI.encode_www_form(params)\n`;
    } else if (Object.keys(payload).length > 0) {
      uriInitializationSnippet = `uri = URI(url)\n`;
    }

    const rubySnippet = `require 'net/http'\n` +
        `require 'json'\n` +
        `url = "${url}"\n` +
        `headers = ${JSON.stringify(headers)}\n` +
        `${paramSnippet}${payloadSnippet}\n` +
        `${uriInitializationSnippet}\n` +
        `http = Net::HTTP.new(uri.host, uri.port)\n` +
        `http.use_ssl = true # Uncomment this line if using HTTPS\n` +
        `request = Net::HTTP::${this.capitalizeFirstLetter(params.method.toLowerCase())}.new(uri.request_uri)\n` +
        `request['Content-Type'] = headers['Content-Type']\n` +
        `headers.each do |key, value|\n` +
        `    next if key == 'Content-Type'\n` +
        `    request[key] = value\n` +
        `end\n` +
        `${requestCallSnippet}\n` +
        `response = http.request(request)\n` +
        `puts response.body\n`;

    this.RubySnippet = rubySnippet;
  }

  getPythonCodeSnippet() {
    let url: string = this.operations[0]['apiUrl'];
    const host: any = this.operations[0]['apiUrl'].split('://')[1].split('/')[0];
    url = url.split(/\/[{:]|\/:/)[0];

    if (this.isNotEmpty(this.operations[0]['pathParams'])) {
      for (const path of this.operations[0]['pathParams']) {
        url += `/${path['value']}`;
      }
    }
    const headers = {};
    if (this.operations[0]['headers']) {
      for (const header of this.operations[0]['headers']) {
        headers[header['key']] = header['value'];
      }
    }

    let requestCallSnippet = '';
    const queryParams = {};
    let paramSnippet = '';
    if (this.isNotEmpty(this.operations[0]['queryParams'])) {
      for (const qp of this.operations[0]['queryParams']) {
        queryParams[qp['key']] = qp['value'];
      }
      paramSnippet = `params = ${JSON.stringify(queryParams)}\n`;
    }

    const params = {
      url: url,
      method: this.operations[0]['executor_method_type'],
      headers: {}
    };

    let body = {};
    if (this.operations[0]['requestBody'] !== null && this.operations[0]['requestBody'] !== undefined) {
      if (this.operations[0]['requestBody']['value'] !== undefined && this.operations[0]['requestBody']['value'] !== null) {
        const requestBodyValue = this.operations[0]['requestBody']['value'];
        if (Array.isArray(requestBodyValue)) {
          for (const rqb of requestBodyValue) {
            body[rqb['key']] = rqb['value'];
          }
        } else {
          body = this.operations[0]['requestBody']['value'];
        }
      }
    }

    let payload = {};
    let payloadSnippet = '';

    if (Object.keys(body).length > 0) {
      if (headers['Content-Type'] === 'application/json') {
        payload = JSON.stringify(body);
        payloadSnippet = `payload = json.dumps(${payload})\n`;
      } else if (headers['Content-Type'] === 'application/x-www-form-urlencoded') {
        payload = body;
        payloadSnippet = `payload = ${JSON.stringify(payload)}\n`;
      } else if (headers['Content-Type'] === 'multipart/form-data') {
        delete headers['Content-Type'];
        // const formData = new FormData();
        // for (const key in body) {
        //     if (body.hasOwnProperty(key)) {
        //         formData.append(key, body[key]);
        //     }
        // }
        payload = body;
        payloadSnippet = `payload = ${JSON.stringify(payload)}\n`;
      } else {
        payload = body;
        payloadSnippet = `payload = ${JSON.stringify(payload)}\n`;
      }
    }

    if (Object.keys(queryParams).length > 0 && Object.keys(payload).length > 0) {
      requestCallSnippet = `(url, params=params, data=payload, headers=headers)`;
    } else if (Object.keys(queryParams).length > 0 && Object.keys(payload).length === 0) {
      requestCallSnippet = `(url, params=params, headers=headers)`;
    } else if (Object.keys(queryParams).length === 0 && Object.keys(payload).length > 0) {
      requestCallSnippet = `(url, data=payload, headers=headers)`;
    }

    this.PySnippet = `import requests\nimport json\nurl = "${url}" \nheaders = ${JSON.stringify(headers)}\n${paramSnippet}${payloadSnippet}response = requests.${params.method.toLowerCase()}${requestCallSnippet}\nprint(response.text)`;
  }

  getCurlCodeSnippet() {
    const params = this.getRequestOptions();
    let contentType = params.headers['Content-Type'];
    if (contentType === 'multipart/form-data') {
      delete params.headers["Content-Type"];
    }

    this.curlSnippet = CurlGenerator(params);

    let body = this.getRequestPayload();

    if (Object.keys(body).length > 0) {
      if (contentType === 'application/json') {
        this.curlSnippet += ` -d '${JSON.stringify(body)}'`;
      } else if (contentType === 'application/x-www-form-urlencoded' || contentType === 'multipart/form-data') {
        Object.entries(body).forEach(([key, value], index) => {
          this.curlSnippet += ` -d ${key}=${value}`;
        });
      } else {
        this.curlSnippet += ` -d '${body}'`;
      }
    }
    // if (params.headers['Content-Type'] && body!==null && body !==undefined ) {
    //     if (params.headers['Content-Type'] === 'application/x-www-form-urlencoded'||params.headers['Content-Type'] === 'multipart/form-data') {
    //             Object.entries(body).forEach(([key, value], index) => {
    //                 this.curlSnippet += ` -d ${key}=${value}`;
    //             });
    //         } else {
    //             this.curlSnippet += ` -d '${JSON.stringify(body)}'`;
    //         }
    //     }
  }

  getJsCodeSnippet() {
    const params = this.getRequestOptions();
    let body = this.getRequestPayload();

    this.JSSnippet = 'var settings = {\n';
    this.JSSnippet = this.JSSnippet + '\"url\":\"' + params['url'] + '\",\n';
    this.JSSnippet = this.JSSnippet + `\"method\": \"${params['method']}\",\n`;
    this.JSSnippet = this.JSSnippet + '\"timeout\": 0,\n';
    this.JSSnippet = this.JSSnippet + `\"data\": ${JSON.stringify(body)},\n`;
    this.JSSnippet = this.JSSnippet + '\"headers\": {\n';
    if (this.operations[0]['headers']) {
      for (const header of this.operations[0]['headers']) {
        if (header['key'] != "Content-Type")
          this.JSSnippet = this.JSSnippet + '\"' + header['key'] + '\" : \"' + header['value'] + '\",\n';
      }
    }
    this.JSSnippet = this.JSSnippet + '},\n';
    this.JSSnippet = this.JSSnippet + '};\n';
    this.JSSnippet = this.JSSnippet + '$.ajax(settings).done(function (response) {';
    this.JSSnippet = this.JSSnippet + 'console.log(response);';
    this.JSSnippet = this.JSSnippet + '});\n';
  }

  getGoCodeSnippet() {
    let params = this.getRequestOptions()
    const url = params.url;
    const method = params.method;
    const headers = params.headers;
    const body = this.getRequestPayload();
    let importSnippet = "package main\n\n import (\n\t\"fmt\"\n\t\"io/ioutil\"\n\t\"net/http\"\n";
    let reqBodySnippet = ""
    let bodyBufferSnippet = ""
    let requestBodyFunction = "nil"
    let reqHeaderSnippet = ""
    if (Object.keys(body).length > 0) {
      if(this.isNotEmpty(headers['Content-Type'])){
        if (headers['Content-Type'] === 'application/json') {
          reqHeaderSnippet += `\treq.Header.Set("Content-Type", "${headers['Content-Type']}")\n`
          importSnippet += "\t\"strings\"\n"
          reqBodySnippet += `\treq.Body = ioutil.NopCloser(strings.NewReader(\`${JSON.stringify(body)}\`))`
        } else if (headers['Content-Type'] === 'application/x-www-form-urlencoded' || headers['Content-Type'] === 'text/plain') {
          let payload = "";
          Object.entries(body).forEach(([key, value], index) => {
            payload += `${key}=${value}&`;
          });
          payload = payload.slice(0, -1);
          importSnippet += "\t\"strings\"\n"
          reqHeaderSnippet += `\treq.Header.Set("Content-Type", "${headers['Content-Type']}")\n`
          reqBodySnippet += `\treq.Body = ioutil.NopCloser(strings.NewReader("${payload}"))`
        } else if (headers['Content-Type'] === 'multipart/form-data') {
          importSnippet += "\t\"mime/multipart\"\n"
          importSnippet += "\t\"bytes\"\n"
          bodyBufferSnippet += "\tbodyBuf := &bytes.Buffer{}\n" +
              "\tbodyWriter := multipart.NewWriter(bodyBuf)"
          Object.entries(body).forEach(([key, value], index) => {
            bodyBufferSnippet += `\n\t_ = bodyWriter.WriteField("${key}", "${value}")`;
          });
          bodyBufferSnippet += "\n\tbodyWriter.Close()\n"
          requestBodyFunction = "bodyBuf"
          reqHeaderSnippet += "\treq.Header.Set(\"Content-Type\", bodyWriter.FormDataContentType())\n"
        } else {
          importSnippet += "\t\"strings\"\n"
          reqHeaderSnippet += `\treq.Header.Set("Content-Type", "${headers['Content-Type']}")\n`
          reqBodySnippet += `\treq.Body = ioutil.NopCloser(strings.NewReader(\`${JSON.stringify(body)}\`))`
        }
      }else{
        importSnippet += "\t\"strings\"\n"
        reqBodySnippet += `\treq.Body = ioutil.NopCloser(strings.NewReader(\`${JSON.stringify(body)}\`))`
      }
    }

    this.GoSnippet = importSnippet + ")\n\n";
    this.GoSnippet += "func main() {\n";
    this.GoSnippet += "\t" + `url := "${url}"` + "\n";
    this.GoSnippet += "\t" + `method := "${method}"` + "\n";
    this.GoSnippet += "\tclient := &http.Client{}\n";
    this.GoSnippet += bodyBufferSnippet
    this.GoSnippet += `\treq, err := http.NewRequest(method, url, ${requestBodyFunction})\n`;
    this.GoSnippet += "\tif err != nil {\n";
    this.GoSnippet += '\t\tfmt.Println("Error creating request:", err)\n';
    this.GoSnippet += "\t\treturn\n";
    this.GoSnippet += "\t}\n\n";
    this.GoSnippet += "\t// Set headers\n";
    for (const key in headers) {
      if (key != "Content-Type") {
        const value = headers[key];
        reqHeaderSnippet += "\t" + `req.Header.Set("${key}", "${value}")` + "\n";
      }
    }
    this.GoSnippet += reqHeaderSnippet
    this.GoSnippet += "\n";
    this.GoSnippet += reqBodySnippet
    this.GoSnippet += "\n";
    this.GoSnippet += "\tres, err := client.Do(req)\n";
    this.GoSnippet += "\tif err != nil {\n";
    this.GoSnippet += '\t\tfmt.Println("Error making request:", err)\n';
    this.GoSnippet += "\t\treturn\n";
    this.GoSnippet += "\t}\n";
    this.GoSnippet += "\tdefer res.Body.Close()\n\n";
    this.GoSnippet += "\tbody, err := ioutil.ReadAll(res.Body)\n";
    this.GoSnippet += "\tif err != nil {\n";
    this.GoSnippet += '\t\tfmt.Println("Error reading response body:", err)\n';
    this.GoSnippet += "\t\treturn\n";
    this.GoSnippet += "\t}\n\n";
    this.GoSnippet += "\tfmt.Println(string(res.Status))\n";
    this.GoSnippet += "\tfmt.Println(string(body))\n";
    this.GoSnippet += "}\n";

  }

  private getRequestOptions() {
    let url: string = this.operations[0]['apiUrl'];
    url = url.split(/\/[{:]|\/:/)[0];
    if (this.operations[0]['pathParams'] !== undefined && this.operations[0]['pathParams'] !== null) {
      for (const path of this.operations[0]['pathParams']) {
        url += `/${path['value']}`;
      }
    }
    url += '?';
    if (this.operations[0]['queryParams'] !== undefined && this.operations[0]['queryParams'] !== null) {
      for (const path of this.operations[0]['queryParams']) {
        url += `${path['key']}=${path['value']}&`;
      }
    }
    url = url.slice(0, -1);

    const params = {
      url: url,
      method: this.operations[0]['executor_method_type'],
      headers: {}
    };

    if (this.operations[0]['headers']) {
      for (const header of this.operations[0]['headers']) {
        params['headers'][header['key']] = header['value'];
      }
    }

    return params;
  }

  private getRequestPayload() {
    let body = {};
    if (this.operations[0]['requestBody'] !== null && this.operations[0]['requestBody'] !== undefined) {
      let requestBody = this.operations[0]['requestBody']['value'];
      if (requestBody !== undefined && requestBody !== null) {
        if (Array.isArray(requestBody)) {
          for (const rqb of requestBody) {
            body[rqb['key']] = rqb['value'];
          }
        } else if (this.isMap(requestBody)) {
          requestBody.forEach(function (value, key) {
            body[key] = value;
          });
        } else {
          body = requestBody;
        }
      }
    }
    return body;
  }

  getJavaSnippet(): void {
    let url: string = this.operations[0]['apiUrl'];
    const host: any = this.operations[0]['apiUrl'].split('://')[1].split('/')[0];
    url = url.split(/\/[{:]|\/:/)[0];

    let importPkgsSnippet = '';

    if (this.operations[0]['pathParams'] !== undefined && this.operations[0]['pathParams'] !== null) {
      for (const path of this.operations[0]['pathParams']) {
        url += `/${path['value']}`;
      }
    }

    let headers = new HttpHeaders();
    if (this.operations[0]['headers']) {
      for (const header of this.operations[0]['headers']) {
        headers = headers.append(header['key'], header['value']);
      }
    }

    let queryParams = new HttpParams();
    if (
        this.operations[0]['queryParams'] !== undefined &&
        this.operations[0]['queryParams'] !== null &&
        this.operations[0]['queryParams'].length > 0
    ) {
      for (const qp of this.operations[0]['queryParams']) {
        queryParams = queryParams.append(qp['key'], qp['value']);
      }
    }

    let body = {};
    if (
        this.operations[0]['requestBody'] !== null &&
        this.operations[0]['requestBody'] !== undefined &&
        this.operations[0]['requestBody']['value'] !== undefined &&
        this.operations[0]['requestBody']['value'] !== null
    ) {
      const requestBodyValue = this.operations[0]['requestBody']['value'];
      if (Array.isArray(requestBodyValue)) {
        for (const rqb of requestBodyValue) {
          body[rqb['key']] = rqb['value'];
        }
      } else {
        body = this.operations[0]['requestBody']['value'];
      }
    }

    let HttpEntitySnippet = '';
    HttpEntitySnippet = `HttpEntity<String> requestEntity = new HttpEntity<>(headers);`;

    let payload = {};
    let payloadSnippet = '';

    if (Object.keys(body).length > 0) {
      if (headers.get('Content-Type') === 'application/json') {
        payload = JSON.stringify(body).replace(/\\/g, '\\\\').replace(/"/g, '\\\"');
        payloadSnippet = `String payload = "${payload}";`;
        HttpEntitySnippet = `HttpEntity<String> requestEntity = new HttpEntity<>(payload, headers);`;
      } else if (headers.get('Content-Type') === 'application/x-www-form-urlencoded') {
        payload = body;
        importPkgsSnippet = `import org.springframework.util.LinkedMultiValueMap;\nimport org.springframework.util.MultiValueMap;\nimport java.nio.charset.StandardCharsets;\n`;
        payloadSnippet = `MultiValueMap<String, String> formData = new LinkedMultiValueMap<>();\n`;
        for (const key of Object.keys(payload)) {
          payloadSnippet += `formData.add("${key}", "${payload[key]}");\n`;
        }
        payloadSnippet += ` String encodedFormData = formData.keySet().stream()
            .map(key -> key + "=" + URLEncoder.encode(formData.getFirst(key), StandardCharsets.UTF_8))
            .reduce((param1, param2) -> param1 + "&" + param2)
            .orElse("");`;
        HttpEntitySnippet = `HttpEntity<String> requestEntity = new HttpEntity<>(encodedFormData, headers);\n`;
      } else if (headers.get('Content-Type') === 'multipart/form-data') {
        headers = headers.delete('Content-Type');
        // MultipartBodyBuilder multipartBodyBuilder = new MultipartBodyBuilder();
        // for (Map.Entry<String, Object> entry : body.entrySet()) {
        //     multipartBodyBuilder.addFormDataPart(entry.getKey(), entry.getValue().toString());
        // }
        payload = body;
        importPkgsSnippet = `import org.springframework.util.LinkedMultiValueMap;\nimport org.springframework.util.MultiValueMap;\n`;
        payloadSnippet = `MultiValueMap<String, Object> formData = new LinkedMultiValueMap<>();\n`;
        for (const key of Object.keys(payload)) {
          payloadSnippet += `formData.add("${key}", "${payload[key]}");\n`;
        }
        payloadSnippet += `headers.setContentType(MediaType.MULTIPART_FORM_DATA);\n`;
        HttpEntitySnippet = `HttpEntity<MultiValueMap<String, Object>> requestEntity = new HttpEntity<>(formData, headers);\n`;
      } else {
        payload = body;
        payloadSnippet = `String payload = ${JSON.stringify(payload)};`;
      }
    }

    const javaSnippet = `import org.springframework.http.*;` +
        `\nimport org.springframework.web.client.RestTemplate;` +
        `\nimport org.springframework.web.util.UriComponentsBuilder;` +
        `${importPkgsSnippet}` +
        `\n` +
        `\nimport java.net.URI;` +
        `\nimport java.net.URLEncoder;` +
        `\n` +
        `\nclass Main {` +
        `\n  public static void main(String[] args) {` +
        `\n    String url = "${url}";` +
        `\n    HttpHeaders headers = new HttpHeaders();` +
        `${headers.keys().map((key) => `\n    headers.add("${key}", "${headers.get(key)}");`).join('')}` +
        `\n` +
        `\n    UriComponentsBuilder uriBuilder = UriComponentsBuilder.fromUriString(url);` +
        `${queryParams.keys().map((key) => `\n    uriBuilder.queryParam("${key}", "${queryParams.get(key)}");`).join('')}` +
        `\n    URI uri = uriBuilder.build().encode().toUri();` +
        `\n` +
        `\n    RestTemplate restTemplate = new RestTemplate();` +
        `\n    HttpMethod httpMethod = HttpMethod.${this.capitalizeFirstLetter(this.operations[0]['executor_method_type'])};` +
        `\n    ${payloadSnippet}` +
        `\n    ${HttpEntitySnippet}` +
        `\n    ResponseEntity<String> response = restTemplate.exchange(uri, httpMethod, requestEntity, String.class);` +
        `\n    System.out.println(response.getBody());` +
        `\n  }` +
        `\n}`;


    this.JavaSnippet = javaSnippet;
  }


  isNotEmpty(variable: any): boolean {
    if (variable === null || variable === undefined) {
      return false;
    }

    if (typeof variable === 'string' || Array.isArray(variable)) {
      return variable.length > 0;
    }

    if (typeof variable === 'object') {
      return Object.keys(variable).length > 0;
    }

    return Boolean(variable);
  }


  splitHostnameAndPath(urlString: string): { hostname: string, pathname: string } {
    const regex = /^(?:https?:\/\/)?([^/]+)(.*)$/;
    const match = urlString.match(regex);

    if (match && match.length >= 3) {
      const hostname = match[1];
      const pathname = match[2];

      return {hostname, pathname};
    }
    return {hostname: '', pathname: ''};
  }


  capitalizeFirstLetter(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  getParameterTableName(val) {
    if (val != null && val.length !== 0) {
      return val.toLowerCase() + 'OperationTable';
    }
    return 'OperationTable';
  }

  getHeaderTableName(val) {
    if (val != null && val.length !== 0) {
      return val.toLowerCase() + 'HeaderTable';
    }
    return 'HeaderTable';
  }

  getRequestBody() {
    const requestbody = {
      'type': this.requestBodySelected,
      'value': this.getRequestBodyValue(this.requestBodySelected)
    };
    return requestbody;
  }

  getRequestBodyValue(val) {
    switch (val) {
      case 'raw':
        return this.editor.get();

      case 'binary':
      case 'none':
      default:
    }
  }

  stringifyjson(val) {
    if (val != null) {
      return JSON.stringify(val, null, 2).trim();
    } else {
      return val;
    }
  }

  print(val) {
    if (val != null) {
      return val.trim();
    }
    return val;
  }

  getHeaders(type) {
    const headers = [];
    switch (type.toLowerCase()) {
      case 'get':
        $('#getHeaderTable').children('tbody').children('tr').each(function () {
          const header = {};
          header['key'] = $(this).find('td:first').find('input').val();
          header['value'] = $(this).find('td:eq(1)').find('input').val();
          headers.push(header);
        });
        return headers;
      case 'put':
        $('#putHeaderTable').children('tbody').children('tr').each(function () {
          const header = {};
          header['key'] = $(this).find('td:first').find('input').val();
          header['value'] = $(this).find('td:eq(1)').find('input').val();
          headers.push(header);
        });
        return headers;
      case 'post':
        $('#postHeaderTable').children('tbody').children('tr').each(function () {
          const header = {};
          header['key'] = $(this).find('td:first').find('input').val();
          header['value'] = $(this).find('td:eq(1)').find('input').val();
          headers.push(header);
        });
        return headers;
      case 'delete':
        $('#deleteHeaderTable').children('tbody').children('tr').each(function () {
          const header = {};
          header['key'] = $(this).find('td:first').find('input').val();
          header['value'] = $(this).find('td:eq(1)').find('input').val();
          headers.push(header);
        });
        return headers;
      default:
        break;
    }
  }

  getParameters(type) {
    const parameters = [];
    switch (type.toLowerCase()) {
      case 'get':
        $('#getOperationTable').children('tbody').children('tr').each(function () {
          const parameter = {};
          if ($('#GETquery').val()) {
            parameter['key'] = $(this).find('td:first').find('b').find('mat-label').text();
            parameter['value'] = $(this).find('td:eq(1)').find('input').val();
            parameters.push(parameter);
          }
        });
        return parameters;
      case 'put':
        $('#putOperationTable').children('tbody').children('tr').each(function () {
          const parameter = {};
          parameter['key'] = $(this).find('td:first').find('input').val();
          parameter['value'] = $(this).find('td:eq(1)').find('input').val();
          parameters.push(parameter);
        });
        return parameters;
      case 'post':
        $('#postOperationTable').children('tbody').children('tr').each(function () {
          const parameter = {};
          parameter['key'] = $(this).find('td:first').find('input').val();
          parameter['value'] = $(this).find('td:eq(1)').find('input').val();
          parameters.push(parameter);
        });
        return parameters;
      case 'delete':
        $('#deleteOperationTable').children('tbody').children('tr').each(function () {
          const parameter = {};
          parameter['key'] = $(this).find('td:first').find('input').val();
          parameter['value'] = $(this).find('td:eq(1)').find('input').val();
          parameters.push(parameter);
        });
        return parameters;
      default:
        break;
    }
  }

  saveDescription(attr, value) {
    attr.description = value;
  }

  saveExecutorDescription(attr, value) {
    attr.executor_description = value;
  }

  saveExecutorDisplayName(attr, value) {
    attr.executor_display_name = value.display_name;
    value.edit_executor_display_name = false;
  }

  executeApi(type, url, headers, parameters, authModel, requestBody1, prerequisites, pathparams) {

    const requestBodyResponse = this.headerChild.getRequestBody();
    let requestBody = {value: '', key: 'payload', description: 'Document in JSON format', annotation: 'RequestBody'};
    if (requestBodyResponse && requestBodyResponse !== null && requestBodyResponse !== undefined && requestBodyResponse.hasOwnProperty('__zone_symbol__value')) {
      if (requestBodyResponse['__zone_symbol__value'] && requestBodyResponse['__zone_symbol__value'] !== undefined && requestBodyResponse['__zone_symbol__value'] !== null && requestBodyResponse['__zone_symbol__value'] !== '') {
        requestBody = requestBodyResponse['__zone_symbol__value'];
      }
    }
    const payload = {
      'executor_name': '',
      'executor_type': 'API',
      'executor_method_type': type,
      'apiUrl': url,
      'dataroot': null,
      'pathParams': pathparams,
      'queryParams': parameters,
      'headers': headers,
      'requestBody': requestBody,
      'prerequisites': prerequisites
    };
    payload['authModel'] = this.headerChild.authModel1.getAuthModel();
    // if (this.authModel1) {
    //   payload['authModel'] = this.authModel1.authModel;
    // } else {
    //   payload['authModel'] = authModel;
    // }

    const startTime = performance.now();
    this.executeFlag = true;
    this._service.executeApi(payload).subscribe(response2 => {
      const endTime = performance.now();
      this.executeFlag = false;
      this.responses = response2;
      this.responseItems = this.responses.body;
      this.httpUrl = payload['apiUrl'];
      // if (this.responseItems.attributes !== null && this.responseItems.attributes !== undefined) {
      //
      // }
      if (this.responseItems && this.responseItems.attributes) {
        for (let i = 0; i < this.responseItems.attributes.length; i++) {
          this.itemList.push({id: i, itemName: this.responseItems.attributes[i].attributeName});
        }
        for (const attribute of this.responseItems.attributes) {
          if (attribute['attributeName'].includes('$.result.')) {
            attribute['attributeName'] = attribute['attributeName'].replace('$.result.', '');
          }
        }
        this.apiByDefinition = this.responseItems.attributes;
      }
      if (this.responseItems && this.responseItems.statusCode) {
        this.responseCode = this.responseItems.statusCode;
      }
      if (this.responseCode && this.responseCode >= 400) {
        this.error = true;
      } else {
        this.error = false;
      }
      if (this.error) {
        if (this.responseItems && this.responseItems.body && this.responseItems.body['message']) {
          this.responseData = JSON.parse(JSON.stringify(this.responseItems.body));
          this.errorMessage = this.responseData['message'];
          this.responseError = this.responseData['error'];
        } else if (!this.responseItems.body['message'] && this.responseItems && this.responseItems.body) {
          this.responseData = JSON.parse(JSON.stringify(this.responseItems.body));
          if (this.responseData.hasOwnProperty('error')) {
            this.errorMessage = this.responseData['error']['message'];
          } else {
            this.errorMessage = this.responseItems.body;
          }
        } else {
          this.errorMessage = this.getErrorMessage(this.responseCode); //this.responseItems.message;
          if (this.responseItems.error) {
            this.responseError = this.responseItems.error;
          }
        }
      }
      if (this.responseItems && this.responseItems.headers) {
        this.responseHeaders = this.responseItems.headers;
      }
      if (this.responseHeaders && this.responseHeaders.length > 0) {
        const contentType = this.responseHeaders.filter(element => element.name.toLowerCase() === 'content-type');
        // for (let i = 0; i < this.responseHeaders.length; i++) {
        //     if (this.responseHeaders[i]['name'] === 'Content-Type'){
        if (contentType && contentType.length > 0 && contentType[0]['name'] === 'content-type') {
          if (contentType[0]['value'].includes('json')) {
            this.responseType = 'json';
            this.userView = 'json';
          } else if (contentType[0]['value'].includes('html')) {
            this.responseType = 'html';
            this.userView = 'html';
          } else if (contentType[0]['value'].includes('text')) {
            this.responseType = 'text';
            this.userView = 'text';
          } else if (contentType[0]['value'].includes('xml')) {
            this.responseType = 'xml';
            this.userView = 'xml';
          } else {
            this.platform.openSnackBar('We do not support the response type you are trying to view.', 'Info', {
              duration: 2000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
            this.responseType = 'json';
          }
        }
        // }
        if (this.responseType === '' || this.responseType === undefined || this.responseType === null) {
          this.responseType = 'json';
        }
        if (this.responseHeaders && this.responseHeaders.length > 0 && this.responseItems && this.responseItems.body) {
          // contentType = this.responseHeaders.filter(element => element.name.toLowerCase() === 'content-type');
          if (contentType && contentType.length > 0 && contentType[0]['name'].toLowerCase() === 'content-type') {
            if (contentType[0]['value'].includes('application/json')) {
              this.responseType = 'json';
              this.userView = 'json';
              if (this.responseItems.body.startsWith('[{')) {
                this.returnType = 'Array';
                this.responseData = JSON.parse(this.responseItems.body);
                this.jsonViewer = this.stringifyjson(this.responseData);
              } else if (this.responseItems.body.startsWith('{')) {
                this.returnType = 'JSON Object';
                this.responseData = [];
                this.responseData.push(JSON.parse(this.responseItems.body));
                this.jsonViewer = this.stringifyjson(this.responseData[0]);
              } else if (this.responseItems.body.startsWith('[')) {
                this.returnType = 'Array';
                this.responseData = JSON.parse(this.responseItems.body);
                this.jsonViewer = this.stringifyjson(this.responseData);
              }
            } else if (contentType[0]['value'].includes('application/xml') || contentType[0]['value'].includes('text/xml')) {
              if (contentType[0]['value'].includes('application/xml')) {
                this.responseType = 'xml';
                const parser = new DOMParser();
                const xmlDoc = parser.parseFromString(this.responseItems.body, 'application/xml');
                this.responseText = this.prettifyXml(xmlDoc);
                this.returnType = 'XML';
                this.userView = 'xml';
              } else if (contentType[0]['value'].includes('text/xml')) {
                this.responseType = 'xml';
                const parser = new DOMParser();
                const xmlDoc = parser.parseFromString(this.responseItems.body, 'text/xml');
                this.responseText = this.prettifyXml(xmlDoc);
                this.returnType = 'XML';
                this.userView = 'xml';
              } else {
                this.responseType = 'text';
                this.returnType = 'Text';
                this.responseText = (this.responseItems && this.responseItems.hasOwnProperty('body')) ? this.responseItems.body : '';
                this.userView = 'text';
              }
            } else if (contentType[0]['value'].includes('text/html')) {
              this.responseType = 'html';
              this.responseText = this.responseItems.body;
              this.returnType = 'HTML';
              this.userView = 'html';
            } else {
              this.responseType = 'text';
              this.returnType = 'Text';
              this.responseText = (this.responseItems && this.responseItems.hasOwnProperty('body')) ? this.responseItems.body : '';
              this.userView = 'text';
            }
          } else {
            this.responseType = 'text';
            this.returnType = 'Text';
            this.responseText = (this.responseItems && this.responseItems.hasOwnProperty('body')) ? this.responseItems.body : '';
            this.userView = 'text';
          }
        }

      } else {
        this.responseType = 'text';
        this.returnType = 'Text';
        this.responseText = (this.responseItems && this.responseItems.hasOwnProperty('body')) ? this.responseItems.body : '';
        this.userView = 'text';
      }
      this.responseTime = Math.round(endTime - startTime);
    }, error => {
      this.executeFlag = false;
      this.getResponse = error;
    });
    this.getDevex();
  }

  getStatusCodeStyle(val) {
    if (val < 400) {
      return 'status-ok';
    } else {
      return 'status-not-ok';
    }
  }

  typeOfval(val) {
    return typeof val;
  }

  prettifyXml(xmlDoc) {
    // const xmlDoc = new DOMParser().parseFromString(sourceXml, type);
    const xsltDoc = new DOMParser().parseFromString([
      // describes how we want to modify the XML - indent everything
      '<xsl:stylesheet xmlns:xsl="http://www.w3.org/1999/XSL/Transform">',
      '  <xsl:strip-space elements="*"/>',
      '  <xsl:template match="para[content-style][not(text())]">', // change to just text() to strip space in text nodes
      '    <xsl:value-of select="normalize-space(.)"/>',
      '  </xsl:template>',
      '  <xsl:template match="node()|@*">',
      '    <xsl:copy><xsl:apply-templates select="node()|@*"/></xsl:copy>',
      '  </xsl:template>',
      '  <xsl:output indent="yes"/>',
      '</xsl:stylesheet>',
    ].join('\n'), 'application/xml');

    const xsltProcessor = new XSLTProcessor();
    xsltProcessor.importStylesheet(xsltDoc);
    const resultDoc = xsltProcessor.transformToDocument(xmlDoc);
    const resultXml = new XMLSerializer().serializeToString(resultDoc);
    return resultXml;
  }

  getErrorMessage(errorCode) {
    switch (errorCode) {
      case 400:
        return 'Bad Request';
      case 401:
        return 'Unauthorized';
      case 402:
        return 'Payment Required';
      case 403:
        return 'Forbidden';
      case 404:
        return 'Not Found';
      case 405:
        return 'Method Not Allowed';
      case 406:
        return 'Not Acceptable';
      case 407:
        return 'Proxy Authentication Required';
      case 408:
        return 'Request Timeout';
      case 409:
        return 'Conflict';
      case 410:
        return 'Gone';
      case 411:
        return 'Length Required';
      case 412:
        return 'Precondition Failed';
      case 413:
        return 'Payload Too Large';
      case 414:
        return 'URI Too Long';
      case 415:
        return 'Unsupported Media Type';
      case 416:
        return 'Range Not Satisfiable';
      case 417:
        return 'Expectation Failed';
      case 418:
        return 'I am a teapot';

    }
  }

  openResponseSettingsDialog(executor) {
    const dialogRef = this.dialog.open(ResponseSettingsComponent, {
      width: '80%',
      height: '80%',
      data: {executor: executor}
    });

    dialogRef.afterClosed().subscribe(async result => {
      this.entityApiResponses.forEach(arr => {
        if (arr.method === executor.executor_method_type) {
          arr.mockResponses = executor.mockResponses;
        }
      });

      this.eARChanged.emit(this.entityApiResponses);
    });
  }

  TestEndpoints(type, url, pkey) {

    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'pkey': pkey,
        'Access-Control-Allow-Origin': '*'
      })
    };

    if (type === 'GET') {
      if (pkey !== undefined) {
        this.getHttpOptions = httpOptions1;
        if ($('#GETdatabase').val() != null && $('#GETdatabase').val().length !== 0 && $('#GETquery').val() != null && $('#GETquery').val().length !== 0) {
          url += '?' + 'database=' + $('#GETdatabase').val() + '&' + 'query=' + $('#GETquery').val();
        } else {
          if ($('#GETdatabase').val() != null && $('#GETdatabase').val().length !== 0) {
            url += '?' + 'database=' + $('#GETdatabase').val();
          }
          if ($('#GETquery').val() != null && $('#GETquery').val().length !== 0) {
            url += '?' + 'query=' + $('#GETquery').val();
          }
        }
        this.getRequest = environment.apihost + '/' + url;
        this._service.getItemsForUrl(url, this.getHttpOptions).subscribe(items => {
          this.getResponse = items;
        });
      } else {
        this.platform.openSnackBar('Please provide a partner key to test the endpoint', 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      }
    } else if (type === 'PUT') {
      this.putHttpOptions = httpOptions1;
      const newUrl = url.replace(/:id/gi, $('#PUTid').val());
      this.putRequest = environment.apihost + '/' + newUrl;

      this.postHttpOptions = httpOptions1;
      this.postRequest = environment.apihost + '/' + url;

      const data = this.editor.get();
      data['id'] = this.dataSource.id;
      this._service.putItemForUrl(newUrl, this.putHttpOptions, data).subscribe(items => {
        this.putResponse = items;
      });
    } else if (type === 'POST') {

      this.postHttpOptions = httpOptions1;
      this.postRequest = environment.apihost + '/' + url;
      const data = this.editor.get();
      data['id'] = this.dataSource.id;

      this._service.postItemForUrl(url, this.postHttpOptions, data).subscribe(items => {
        this.postResponse = items;
      });
    } else if (type === 'DELETE') {
      this.deleteHttpOptions = httpOptions1;
      const newUrl = url.replace(/:id/gi, $('#DELETEid').val());
      this.deleteRequest = environment.apihost + '/' + newUrl;
      this._service.deleteItemForUrl(newUrl, this.deleteHttpOptions).subscribe(items => {
        this.deleteResponse = items;
      });
    } else {

    }
  }

  getData(one, two, three) {
    const data = {
      'type': one,
      'url': two,
      'pkey': three
    };
    return data;
  }

  getDataModel() {
    this.dataModel = {};
    const that = this;
    this.dataSource.forEach((data) => {
      if (data.type !== 'Array') {
        this.dataModel[data.attributeName] = data.type;
      } else {
        this.dataModel[data.attributeName] = (that.getSub(data.subType).length > 0 ? that.getSub(data.subType) : []);
      }
    });
    this.dataModelPut = this.dataModel;
    this.dataModelPost = this.dataModel;
    return this.dataModel;
  }

  getSub(data) {
    const subType = [];
    const obj = {};
    const that = this;
    if (data.length > 0) {
      data.forEach((result) => {
        if (result.type !== 'Array') {
          obj[result.attributeName] = result.type;
        } else {
          obj[result.attributeName] = (that.getSub(result.subType).length > 0 ? that.getSub(result.subType) : []);
        }
      });
      subType.push(obj);
    }
    return subType;
  }

    selectLanguage(event) {
        this.selectedLanguage = event;
    }

  htmlViewChange(value: any) {
    this.htmlViewType = value;
  }

  copyToClipboard() {
    const text_response_ele = document.querySelector('#textAsResponse');
    if (this.codeViewer) {
      const textToCopy = this.codeViewer.getContent();
      navigator.clipboard.writeText(textToCopy);
    } else if (text_response_ele !== null ) {
      const textToCopy = text_response_ele.textContent;
      navigator.clipboard.writeText(textToCopy);
    }
    this.platform.openSnackBar('Copied to clipboard.', 'Success', {
      duration: 2000,
      verticalPosition: 'top',
      horizontalPosition: 'center'
    });
  }
}


@Component({
  selector: 'app-response-settings',
  templateUrl: './response-settings.html',
  styleUrls: ['./response-settings.css']
})
export class ResponseSettingsComponent {


  constructor(
      public platform: LeftpanelComponent, public confPost: ConfService,
      public dialogRef: MatDialogRef<ResponseSettingsComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any) {

    if (!data.executor.mockResponses) {
      data.executor.mockResponses = [];
    }
  }
}
